import { Component } from '@angular/core';

@Component({
  selector: 'app-underutilization-page',
  standalone: false,
  templateUrl: './underutilization-page.component.html',

})
export class UnderutilizationPageComponent {

}
